import React from "react";

import { Link } from "../Tailwind/common/link";
import { Flag } from "../index";

export default function Invoice({ line, me }) {
  if (line) {
    const meContent = me && (
      <span>
        Please{" "}
        <Link
          href={`mailto:accounting@iglu.net?subject=Invoice ${line.invoice_number}`}
          rel="noopener noreferrer"
          target="_blank"
        />
        to review this Invoice
      </span>
    );

    if (!line.is_plausible) {
      return (
        <Flag>
          {meContent ||
            "Please review this Invoice Line Item - the Item Code does not match the Invoice Entity"}
        </Flag>
      );
    } else if (line.invoice_credit_applied) {
      return (
        <Flag color="warning.main">
          {meContent ||
            "Please review the Invoice of this Invoice Line Item - it has at least partly credit applied"}
        </Flag>
      );
    }
  }

  return null;
}
